<div class="action-tablet-movement-order-list">

  <sc-scroll-pane>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.priority"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row">
          @if (row.priority) {
            <sc-icon iconClass="fa-circle-exclamation"></sc-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="referenceDate">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.referenceDate"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row"> {{row.referenceDate | date:'dd.MM.yy H:mm'}} </td>
      </ng-container>

      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.scope"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row">
          <app-transport-scope-icon [scope]="row.scope"></app-transport-scope-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.identifier"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row"> {{row.identifier}} </td>
      </ng-container>

      <ng-container matColumnDef="transportReference">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.transportReference"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row"> {{row.transportReference}} </td>
      </ng-container>

      <ng-container matColumnDef="currentStation">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.currentStation"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row"> {{row.currentStation}} </td>
      </ng-container>

      <ng-container matColumnDef="targetStation">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.targetStation"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row"> {{row.targetStation}} </td>
      </ng-container>

      <ng-container matColumnDef="processingStatus">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.processingStatus.label"></sc-dictionary-label>
        </th>
        <td mat-cell *matCellDef="let row">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.processingStatus.{{row.processingStatus}}"></sc-dictionary-label>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: false"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay" ></tr>

    </table>
  </sc-scroll-pane>

</div>
